import React, { useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import UploadFile from '../shared/UploadFile';
import "./modelform.css";

const ModelForm = ({ show, onHide, onSubmit, model, setFile, error }) => {

  const { register, handleSubmit, formState: { errors, isValid }, reset } = useForm({
    defaultValues: model,
  });

  useEffect(()=>{
    reset(model??{
      name:'',
      email:'',
      password:''
    })
  },[model,reset])

  return (
    <Modal show={show} onHide={onHide} centered className="model-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={`fas ${model ? 'fa-user-edit' : 'fa-user-plus'} me-2`}></i>
          {model ? 'Editar' : 'Crear'} Modelo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)} className="model-professional-form">
          {error && (
            <div className="alert alert-danger py-2 small" role="alert">
              <i className="fas fa-circle-exclamation me-2"></i>{error}
            </div>
          )}
          <div className="mb-4 text-center">
            <UploadFile setFile={setFile} currentImg={model?.img}/>
            <p className="text-muted small mt-2">Formatos sugeridos: JPG, PNG • Máx 2MB</p>
          </div>

          <div className="model-form-group">
            <label className="model-form-label">Nombre Completo</label>
            <div className="model-input-wrapper">
              <i className="fas fa-user"></i>
              <input
                type="text"
                className="model-form-input"
                placeholder="Ingresa el nombre de la modelo"
                {...register('name', { required: true })}
              />
            </div>
            {errors.name && (
              <span className="error-feedback">
                <i className="fas fa-exclamation-circle"></i> Este campo es requerido
              </span>
            )}
          </div>

          <div className="model-form-group">
            <label className="model-form-label">Correo Electrónico</label>
            <div className="model-input-wrapper">
              <i className="fas fa-envelope"></i>
              {/* Al editar se muestra pero no se cambia: es la identidad con la
                  que la modelo inicia sesión, y cambiárselo desde aquí la
                  dejaría fuera de su cuenta sin que se entere. El backend
                  tampoco lo acepta ya. */}
              <input
                type="email"
                className="model-form-input"
                placeholder="correo@ejemplo.com"
                readOnly={Boolean(model)}
                {...register('email', { required: !model })}
              />
            </div>
            {model ? (
              <p className="text-muted x-small mt-1" style={{fontSize: '0.7rem'}}>
                * El correo no se puede modificar.
              </p>
            ) : errors.email && (
              <span className="error-feedback">
                <i className="fas fa-exclamation-circle"></i> Ingresa un correo válido
              </span>
            )}
          </div>

          <div className="model-form-group">
            <label className="model-form-label">Contraseña</label>
            <div className="model-input-wrapper">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                className="model-form-input"
                placeholder={model ? "Nueva contraseña (dejar vacío para mantener)" : "Ingresa la contraseña"}
                {...register('password', { required: model ? false : true })}
              />
            </div>
            {errors.password && (
              <span className="error-feedback">
                <i className="fas fa-exclamation-circle"></i> La contraseña es requerida
              </span>
            )}
            {model && <p className="text-muted x-small mt-1" style={{fontSize: '0.7rem'}}>* Déjala en blanco para conservarla, o escribe una nueva para restablecerla.</p>}
          </div>

          <div className="pt-3">
            <button className="model-submit-btn" type="submit" disabled={!isValid}>
              {model ? 'Actualizar Modelo' : 'Registrar Modelo'}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModelForm;